import { generateContentCategory } from './utils';

export function fbqEventAfterLike(contentName, breadcrumbs, productId, price) {
  window.fbq('track', 'AddToCart', {
    content_name: contentName,
    content_category: typeof breadcrumbs === 'string' ? breadcrumbs : generateContentCategory(breadcrumbs).join(' > '),
    content_ids: [String(productId)],
    content_type: 'product',
    value: `${price}.00`,
    currency: 'UAH',
  });
}
